import React from 'react';
import { useClassName } from 'common/hooks';
import { AnimatedText } from '../../AnimatedText';
import './park-moments.less';
import {
  ExternalLink,
  getContentfulAssetUrlandAlt,
  getContentfulField,
  unwrapContentfulFields,
} from 'common/components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { SocialCarousel } from '../SocialCarousel/SocialCarousel';
import { getStylesByPrefix } from 'public/screens/CustomLandingPage/utils';
import useCustomStyle from 'public/screens/CustomLandingPage/hooks';

export const ParkMoments = ({ venue }) => {
  const className = useClassName('ParkMoments');
  const parkMomentsFields = getContentfulField(
    venue.parkScreen?.parkMoments
  ).fields;
  const title = getContentfulField(parkMomentsFields.title);
  const description = getContentfulField(parkMomentsFields.description);
  const links = getContentfulField(parkMomentsFields.links);
  const logoOverlayAsset = getContentfulField(parkMomentsFields.logoOverlay);
  const logoOverlayFields = logoOverlayAsset?.fields;
  const logoOverlayFieldsFile = getContentfulField(logoOverlayFields.file);
  const logoOverlay = logoOverlayFieldsFile?.url;
  const [, style] = useCustomStyle(
    unwrapContentfulFields(parkMomentsFields.settings)
  );
  const logoOverlayStyle = getStylesByPrefix('--logo-overlay-', style);

  const mappedLinks = (links || []).map((link) => {
    const icon = getContentfulField(
      getContentfulField(link.fields.icon)?.fields?.file
    )?.url;

    return {
      icon,
      label: getContentfulField(link.fields.label),
      url: getContentfulField(link.fields.url),
      type: getContentfulField(link.fields.type),
    };
  });

  const carouselFields = getContentfulField(parkMomentsFields.carousel)?.fields;
  const slides = getContentfulField(carouselFields.slides);

  const mappedSlides = slides.map((slide) => {
    const slideFields = slide.fields;
    let tag = null;
    const tags = getContentfulField(slideFields.tags);

    if (tags && tags.length > 0) {
      tag = tags[0];
    }

    return {
      name: getContentfulField(slideFields.name),
      desktop: getContentfulAssetUrlandAlt(slideFields.desktop),
      mobile: getContentfulAssetUrlandAlt(slideFields.mobile),
      tablet: getContentfulAssetUrlandAlt(slideFields.tablet),
      social: tag,
      url: getContentfulField(slideFields.url),
    };
  });
  return (
    <div className={className('container')}>
      <img
        className={className('logo-overlay')}
        src={logoOverlay}
        alt="Logo Overlay"
        style={logoOverlayStyle}
      />
      <div className={className('header')}>
        <h2 className={className('header__title')}>
          <AnimatedText text={title} />
        </h2>
        <p className={className('header__description')}>
          {documentToReactComponents(description)}
        </p>
      </div>

      <div className={className('social-media')}>
        <div className={className('social-links')}>
          {mappedLinks.map((link, index) => (
            <ExternalLink
              key={`${link.url}-${index}`}
              href={link.url}
              className={className('social-links__link')}>
              <img
                className={className('social-links__link__icon')}
                src={link.icon}
                alt={link.label}
              />
              <span className={className('social-links__link__label')}>
                {link.label}
              </span>
            </ExternalLink>
          ))}
        </div>
        <SocialCarousel slides={mappedSlides} />
      </div>
    </div>
  );
};
